export const EXT_LINKS = {
  PRIVACY_POLICY: "https://www.reshop.com/privacy-policy",
  TERMS_OF_SERVICE: "https://www.reshop.com/terms-of-service",
  REFUND_AGREEMENT: "https://www.reshop.com/reshop-refund-agreement",
  ISSUER_STATEMENT: "https://www.reshop.com/issuer-statement",
  CARDHOLDER_AGREEMENT: "https://www.reshop.com/cardholder-agreement",
  PATHWARD_PRIVACY_POLICY: "https://www.reshop.com/pathward-privacy-policy",
  PATHWARD_SHORT_FORM:
    "https://uploads-ssl.webflow.com/65a83fcf1db1f0d4ff36ab6b/6682fe0b8ceb2602678af539_Reshop%20Card%20-%20Cardholder%20Agreement%20(Short%20Form)%20(Reshop%20July%201%202024).pdf",
  FIND_UPS_STORE: "https://www.theupsstore.com/tools/find-a-store",
  PAYMENT_AUTHORIZATION:
    "https://www.reshop.com/terms-of-service#payment-authorization",
} as const;

export type ExternalLinkKey = keyof typeof EXT_LINKS;
export type ExternalLink = (typeof EXT_LINKS)[ExternalLinkKey];

export const HELP_CENTER_LINKS = {
  default: "https://help.reshop.com/hc/en-us",
  login: {
    login: "https://help.reshop.com/hc/en-us/articles/8631033315855",
  },
  onboarding: {
    mobileVerification:
      "https://help.reshop.com/hc/en-us/articles/8631090468367",
    profileConfirmation:
      "https://help.reshop.com/hc/en-us/articles/8631091647887",
    cardConnection: "https://help.reshop.com/hc/en-us/articles/8631139559823",
  },
  externalConnections: {
    bankAccountError: "https://help.reshop.com/hc/en-us/articles/8631149061519",
    sendRefundToCard:
      "https://help.reshop.com/hc/en-us/articles/11001935929743",
  },
  errors: {
    accountBlocked: "https://help.reshop.com/hc/en-us/articles/8754365984015",
    refundDeclined: "https://help.reshop.com/hc/en-us/articles/8577104440975",
    refundExpired: "https://help.reshop.com/hc/en-us/articles/8632219162255",
  },
};
